import { FC } from 'react';
import * as React from 'react';

const Subtitle: FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <h3 className="font-subtitle3 mb-16">{children}</h3>
);

export default Subtitle;
